import { Injectable } from '@angular/core';

/**
 * Generates a hash code from a string.
 */
@Injectable({
  providedIn: 'root',
})
export class HashService {
  /**
   * Generates an MD5 hash of the input string, following Java's logic
   */
  public generate(contents: string): string {
    let value = 0;
    for (let i = 0; i < contents.length; i++) {
      value = Math.imul(31, value) + contents.charCodeAt(i) | 0;
    }

    return value.toString(16);
  }
}
